
define('text!views/menu/mobile_menu.html',[],function () { return '\r\n<ul class="mobile-menu js-mobile-menu-links"></ul>';});

